import React from 'react';
import Axis from '../Axis/Axis.jsx';

export default (props) => {
  const xSettings = {
    translate: 'translate(0,' + (props.height - props.paddingBottom) + ')',
    scale: props.xScale,
    orient: props.transverse?'top':'bottom',
    tickFormat: props.xTickFormat,
    tickWidth:props.transverse?(props.height - props.paddingTop - props.paddingBottom+5):null,
    ticks: props.xTicks,
    //translateTicks: props.transverse?[0,props.height - props.paddingTop - props.paddingBottom]:null,
    hideAxis: props.hideXAxis?true:false
  };
  const ySettings = {
    translate: 'translate(' + props.paddingLeft + ', 0)',
    scale: props.yScale,
    orient: 'left',
    tickFormat: props.yTickFormat,
    ticks: props.yTicks,
    tickWidth: props.transverse?null:(props.width - props.paddingLeft - props.paddingRight),
    translateTicks: props.transverse?null:[props.width - props.paddingLeft - props.paddingRight,0],
    zeroClass: 'zerotick',
    hideAxis: props.hideYAxis?true:false
  };
  return <g className="xy-axis">
    <Axis {...xSettings}/>
    <Axis {...ySettings}/>
  </g>
}


// WEBPACK FOOTER //
// ./src/js/components/charting/XYAxis/XYAxis.jsx